<template>
  <div>
    <div>
      <v-combobox
          outlined
          style="width: 100%!important;"
          dense
          background-color="#FFF"
          hide-details
          v-model="course"
          class="content-mobile-filter"
          item-text="productName"
          height="44"
          ref="myComboBox"
          placeholder="Filtrar lista de Cursos"
          v-on:keyup.enter="searchForCourseByName"
          :search-input.sync="search"
      >
        <template v-slot:append>
          <v-icon icon color="normalred" size="27" @click="searchForCourseByName">mdi-magnify</v-icon>
        </template>
      </v-combobox>

      <v-expansion-panels
          v-model="panel"
          multiple
          class="content-mobile-filter mt-4"
      >
        <v-expansion-panel v-if="showFilterCategory">
          <v-expansion-panel-header class="ma-0 pa-0 px-2">
            <h4>CATEGORIA</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="ma-0 pa-0  ">
            <v-divider></v-divider>
            <v-radio-group class="mt-1 mb-0" v-model="category">
              <v-radio
                  v-for="category in categories"
                  :key="`${category.id}_category$_`"
                  :value="category.id"
                  color="#BC0000"
                  @click="setCategory(category.id)"
              >
                <template v-slot:label>
                  <strong style="font-size: 16px">{{ category.name }}</strong>
                </template>
              </v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="mt-2">
          <v-expansion-panel-header class="ma-0 pa-0 px-2">
            <h4>NÍVEL</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="ma-0 pa-0  ">
            <v-divider></v-divider>
            <v-radio-group class="mt-1 mb-0" v-model="level">
              <v-radio
                  v-for="level in levels"
                  :key="`${level.value}_level_`"
                  :value="level.value"
                  color="#BC0000"
                  @click="setLevel(level.value)"
              >
                <template v-slot:label>
                  <strong style="font-size: 16px">{{ level.name }}</strong>
                </template>
              </v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="mt-2">
          <v-expansion-panel-header class="ma-0 pa-0 px-2">
            <h4>PERÍODO</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="ma-0 pa-0  ">
            <v-divider></v-divider>
            <v-radio-group class="mt-1" v-model="period">
              <v-radio
                  v-for="period in periods"
                  :key="`${period.value}_period_`"
                  :value="period.value"
                  color="#BC0000"
                  @click="setPeriod(period.value)"
              >
                <template v-slot:label>
                  <strong style="font-size: 16px">{{ period.name }}</strong>
                </template>
              </v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="mt-2">
          <v-expansion-panel-header class="ma-0 pa-0 px-2">
            <h4>BUSCA POR TAGS</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="ma-0 pa-0 pb-2 ">
            <v-divider></v-divider>
            <v-checkbox
                v-for="item in categoriesCourses" :key="item.id"
                v-model="selectedTags"
                color="#BC0000"
                :value="item.id"
                @change="setTags()"
                style="margin-bottom: -30px!important;"
            >
              <template v-slot:label>
                <span id="checkboxLabel">{{ item.name }}</span>
              </template>
            </v-checkbox>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div>
      <v-combobox
          outlined
          style="width: 100%!important;"
          dense
          background-color="#FFF"
          hide-details
          v-model="course"
          class="header_desktop_search desktop"
          item-text="productName"
          height="44"
          ref="myComboBox"
          placeholder="Filtrar lista de Cursos"
          v-on:keyup.enter="searchForCourseByName"
          :search-input.sync="search"
      >
        <template v-slot:append>
          <v-icon icon color="normalred" size="27" @click="searchForCourseByName">mdi-magnify</v-icon>
        </template>
      </v-combobox>
      <div class="filters desktop mt-2">
        <div v-if="showFilterCategory">
          <h4 class="mt-3">CATEGORIA</h4>
          <v-radio-group class="mt-1 mb-0" v-model="category">
            <v-radio
                v-for="(category, index) in categories"
                :key="`${category.id}_category$_${index}`"
                :value="category.id"
                color="#BC0000"
                @click="setCategory(category.id)"
            >
              <template v-slot:label>
                <strong style="font-size: 16px">{{ category.name }}</strong>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <v-divider></v-divider>

        <div>
          <h4 class="mt-3">NÍVEL</h4>
          <v-radio-group class="mt-1 mb-0" v-model="level">
            <v-radio
                v-for="(level, index) in levels"
                :key="`${level.value}_level$_${index}`"
                :value="level.value"
                color="#BC0000"
                @click="setLevel(level.value)"
            >
              <template v-slot:label>
                <strong style="font-size: 16px">{{ level.name }}</strong>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <v-divider></v-divider>
        <div>
          <h4 class="mt-3">PERÍODO</h4>
          <v-radio-group class="mt-1" v-model="period">
            <v-radio
                v-for="period in periods"
                :key="`${period.value}_period`"
                :value="period.value"
                color="#BC0000"
                @change="setPeriod(period.value)"
            >
              <template v-slot:label>
                <strong style="font-size: 16px">{{ period.name }}</strong>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <v-divider></v-divider>
        <div>
          <h4 class="mt-3">BUSCA POR TAGS</h4>
          <div class="  mt-2 d-flex flex-column align-start ml-1">
            <v-checkbox
                v-for="item in categoriesCourses" :key="item.id"
                class="ma-0 pa-0 "
                v-model="selectedTags"
                color="#BC0000"
                :value="item.id"
                @change="setTags()"
                style="margin-bottom: -10px!important;"
            >
              <template v-slot:label>
                <span id="checkboxLabel">{{ item.name }}</span>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pointer {
  cursor: pointer;
}

.title-filter {
  color: #BC0000;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
}

.name-filter {
  color: #2D3038;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.filters-size {
  border-bottom: 1px solid #4F4F4F !important;
}

#checkboxLabel, #checkboxLabelCor, #checkboxLabelMobile, #checkboxLabelCorMobile {
  color: #4F4F4F;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.v-input--checkbox::v-deep {

  .v-label, .v-icon {
    color: #4F4F4F;
    font-size: 28px;
  }

}

.text-search-filter {
  color: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.content-mobile-filter {
  display: none;
}

@media (max-width: 1264px) {
  .desktop {
    display: none;
  }

  .content-mobile-filter {
    width: 100%;
    display: flex;
  }

}

</style>

<script>

import Vue from "vue";
import ApiService from "../../../services/ApiService";

export default {
  name: "Filters",

  props: {
    title: {default: null, type: String},
    showFilterCategory: {default: false, type: Boolean},
  },

  data: () => ({
    panel: [],
    apiService: new ApiService(),
    selected: [],
    search: "",
    course: "",
    selectedTags: [],
    level: -1,
    period: -1,
    levels: [
      {name: 'Todos', value: -1},
      {name: "Iniciante", value: 0},
      {name: "Intermediário", value: 1},
      {name: "Avançado", value: 2}
    ],
    periods: [
      {name: 'Todos', value: -1},
      {name: "Matutino", value: 0},
      {name: "Vespertino", value: 1},
      {name: "Noturno", value: 2}
    ],
    items: [
      {
        text: 'Preço (ascendente)',
        value: 1,
      },
      {
        text: 'Preço (descendente)',
        value: 2,
      },
    ],
    category: -1,
    categoriesCourses: [],
    categories: [],
  }),
  components: {},
  async created() {
    const {category} = this.$route.params
    this.category = category
    await this.getCategoryCoursesTags()
    await this.getCategoryCourses()
  },

  computed: {},

  methods: {
    async getCategoryCoursesTags() {
      try {
        const {content} = await this.apiService.get(`categoryCourses/linkSearch/${this.category}/tags`,)
        this.categoriesCourses = content
      } catch (e) {

      }
    },

    async getCategoryCourses() {
      try {
        const {content} = await this.apiService.get(`categoryCourses/`,)
        this.categories = content
        this.categories.unshift({
          id: -1,
          name: "Todos",
          descriptionHtml: "",
          createdAt: new Date(),
          updatedAt: new Date(),
          deleteddAt: null,
          categoryCoursesToCourses: null,
          linkSearch: "todos"
        })
        this.category = -1
      } catch (e) {

      }
    },

    searchForCourseByName() {
      this.$emit("course", this.search)
    },

    setLevel(level) {
      if (this.level >= 0) {
        this.$emit("set-level", level)
        return
      }
      this.$emit("set-level", null)
    },

    setCategory(category) {
      if(category >= 0){
        this.$emit("set-category", category)
        return
      }
      this.$emit("set-category", null)
    },

    setPeriod(period) {
      if (period >= 0) {
        this.$emit("set-period", period)
        return
      }
      this.$emit("set-period", null)
    },

    setTags() {
      this.$emit("selected-tags", this.selectedTags && this.selectedTags.length > 0 ? this.selectedTags : [])
    }
  },
};
</script>
